import {
	ActionService,
	AuthService,
	AuthAction,
	ProgressService
} from 'phoenix/services';
import { CommonUtilsService } from 'util/util';

const template = require('./login-main.template');

/**
 * @ngdoc directive
 * @name phoenix.directive:pxLoginMain
 * @module phoenix
 * @restrict E
 * @description
 *
 * `pxLoginMain` a view component of `pxLogin`
 *
 * @param {string=} errorMessage This should typically be the application's name.
 * If no title is supplied the control's header will not be displayed
 * @param {string=} emailAddress Email Address used to populate the email input
 */	
export function LoginMainDirective() {
	return {
		restrict: 'E',
		controller: LoginMainController,
		controllerAs: 'vm',
		template,
		scope: {
			errorMessage: '=?',
			emailAddress: '=?'
		},
		bindToController: true
	};
}

class LoginMainController {
	private subscriptions = [];

	public emailAddress:string;
	public errorMessage:string;
	public submitting = false;
	public loginForm;

	public static $inject =  [
		'$stateParams',
		'utils',
		'pxActionService',
		'pxAuthService',
		'pxProgressService',
		'gettextCatalog'
	];

	public constructor(
		$stateParams,
		utils:CommonUtilsService,
		private readonly pxActionService:ActionService,
		private readonly pxAuthService:AuthService, 
		private pxProgressService:ProgressService, 
		private readonly gettextCatalog:ng.gettext.gettextCatalog
	) {
		this.subscriptions.push(
			this.pxActionService.subscribe(AuthAction.AuthStateChanged, () => {
				this.pxProgressService.text = '';
				this.isSubmitting(false);
			})
		);

		if(pxAuthService.rememberedEmail) {
			pxAuthService.sendToIdp(pxAuthService.rememberedEmail, true);
		}

		this.errorMessage = $stateParams.errorMessage ? utils.htmlDecode($stateParams.errorMessage) : '';
	}
	
	public $onDestroy = () => {
		this.subscriptions.forEach(unsubscribe => unsubscribe());
	};

	public login() {
		if (this.loginForm.$valid) {				
			this.errorMessage = '';
			this.pxProgressService.text = this.gettextCatalog.getString('Logging In');
			this.isSubmitting(true);
			this.pxAuthService.sendToIdp(this.emailAddress, true);
		}
	}

	public isSubmitting(submitting) {
		if (submitting) {
			this.pxProgressService.backdrop = submitting;
		}
		this.pxProgressService.visible = submitting;
		this.submitting = submitting;
	}
}


// WEBPACK FOOTER //
// ./src/phoenix/components/login/login-main.component.ts